import { createSelector } from '@reduxjs/toolkit'
import type { AppState } from '@shared-core/store/types'
import { storeKey } from '../slice'

const selectEnvState = (state: AppState) => state[storeKey]

export const selectedCurrentEnv = createSelector(selectEnvState, (s) => s.current)
